import { IFetchStatus } from '../../types/rest/IFetchStatus';
import { ISelectOption } from '../components';

export interface ISetAssociatedLendersAction {
  type: eAssociatedLendersActionType.SetAssociatedLenders;
  payload: { clientId: string; lenders: Array<ISelectOption<string>> };
}

export interface ISetAssociatedLendersFetchStatusAction {
  type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus;
  payload: IFetchStatus;
}

export interface ISetAssociatedLendersErrorAction {
  type: eAssociatedLendersActionType.SetAssociatedLendersError;
  payload: string | null;
}

export interface ISetUpdateAssociatedLendersFetchStatusAction {
  type: eAssociatedLendersActionType.SetUpdateAssociatedLendersFetchStatus;
  payload: IFetchStatus;
}

export interface ISetUpdateAssociatedLendersErrorAction {
  type: eAssociatedLendersActionType.SetUpdateAssociatedLendersError;
  payload: string | null;
}

export type IAssociatedLendersAction =
  | ISetAssociatedLendersAction
  | ISetAssociatedLendersFetchStatusAction
  | ISetAssociatedLendersErrorAction
  | ISetUpdateAssociatedLendersFetchStatusAction
  | ISetUpdateAssociatedLendersErrorAction;

export enum eAssociatedLendersActionType {
  SetAssociatedLendersFetchStatus = 'Set Associated Lenders Fetch Status',
  SetAssociatedLendersError = 'Set Associated Lenders Error',
  SetUpdateAssociatedLendersFetchStatus = 'Set Update Associated Lenders Fetch Status',
  SetUpdateAssociatedLendersError = 'Set Update Associated Lenders Error',
  SetAssociatedLenders = 'Set Associated Lenders',
}

export type AssociatedLendersDispatch = (action: IAssociatedLendersAction) => void;
